import styled from 'styled-components'
import { Button as ButtonKit, Link as LinkKit, Text, theme } from '@mtsdengi/ui-kit'
import { unAuthTheme } from '@mtsdengi/common'

const WrapperTariffs = styled.div`
  border-radius: ${unAuthTheme.radiuses.sm}px;
  background-color: ${theme.colors.mtsdengi.background.primaryElevated};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  & > *:not(:last-child) {
    margin-bottom: ${theme.spacings.md}px;
  }

  padding: ${theme.spacings.sm}px ${theme.spacings.xs}px;

  @media (min-width: ${theme.breakpoints.tablet}px) {
    padding: ${theme.spacings.sm}px ${theme.spacings.md}px;

    & > *:not(:last-child) {
      margin-bottom: ${theme.spacings.sm}px;
    }
  }

  @media (min-width: ${theme.breakpoints.md}px) {
    padding: ${theme.spacings.lg}px;

    & > *:not(:last-child) {
      margin-bottom: 42px;
    }
  }
`

const Card = styled.div<{ isBackgroundColor: boolean }>`
  border-radius: ${unAuthTheme.radiuses.sm}px;
  display: flex;
  flex-direction: column;
  background-color: ${({ isBackgroundColor }) =>
    isBackgroundColor ? theme.colors.mtsdengi.background.secondary : theme.colors.mtsdengi.background.primaryElevated};
  padding: ${theme.spacings.xs}px;

  @media (min-width: ${theme.breakpoints.tablet}px) {
    padding: ${theme.spacings.md}px;
  }

  @media (min-width: ${theme.breakpoints.md}px) {
    padding: 42px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    margin-bottom: ${theme.spacings.xs}px;
  }
`

const RowContent = styled.div`
  display: grid;
  grid-template-columns: 110px 1fr;
  column-gap: ${theme.spacings.sm}px;

  @media (min-width: ${theme.breakpoints.tablet}px) {
    grid-template-columns: 286px 1fr;
    column-gap: 42px;
  }

  @media (min-width: ${theme.breakpoints.md}px) {
    column-gap: 142px;
  }
`

const RowContentDocuments = styled.div`
  display: grid;
  row-gap: 42px;

  @media (min-width: ${theme.breakpoints.tablet}px) {
    row-gap: 0px;
    column-gap: 42px;
    grid-template-columns: 286px 1fr;
  }

  @media (min-width: ${theme.breakpoints.md}px) {
    column-gap: 142px;
  }
`

const ButtonText = styled(Text)`
  padding: ${theme.spacings.xs4}px ${theme.spacings.xs3}px;
  border-radius: ${unAuthTheme.radiuses.xs}px;
`

const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    margin-bottom: ${theme.spacings.xs2}px;
  }
`

const Link = styled(LinkKit)`
  font-family: ${theme.fonts.font_family_comp};
  font-size: ${theme.fonts.font_sizes.par.p4}px;

  @media (min-width: ${theme.breakpoints.tablet}px) {
    font-size: ${theme.fonts.font_sizes.par.p3}px;
  }
`

const Button = styled(ButtonKit)`
  border-radius: ${unAuthTheme.radiuses.xs}px;
`

export const Styled = {
  WrapperTariffs,
  Content,
  Card,
  RowContent,
  RowContentDocuments,
  Button,
  ButtonText,
  LinkWrapper,
  Link,
}
